module.exports = __webpack_public_path__ + "static/fonts/iconfont.ae4a4744.ttf";